module.exports = __webpack_public_path__ + "upload-thin-small.411b9e939953e51fb4bb6ea25e35a592.svg";